"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAccountSummary = exports.selectTablesCalculations = exports.selectCachedIndices = exports.selectPageOperationCurrency = exports.selectTableRows = exports.selectEquity = exports.selectTickers = exports.selectMarginType = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const accountSummaryCalculator_1 = require("../accountSummary/accountSummaryCalculator");
const types_1 = require("../types");
// ----------------------------------------- //
// --------- SELECTORS FROM STATE ---------- //
// ----------------------------------------- //
exports.selectMarginType = (0, toolkit_1.createSelector)([(state) => state.marginType], (marginType) => marginType);
exports.selectTickers = (0, toolkit_1.createSelector)([(state) => state.tickers], (tickers) => tickers);
exports.selectEquity = (0, toolkit_1.createSelector)([(state) => state.equities], (equities) => equities);
exports.selectTableRows = (0, toolkit_1.createSelector)([(state) => state.rows], (rows) => rows);
exports.selectPageOperationCurrency = (0, toolkit_1.createSelector)([(state) => state.pageOperationCurrency], (pageOperationCurrency) => pageOperationCurrency);
exports.selectCachedIndices = (0, toolkit_1.createSelector)([(state) => state.indices], (indices) => indices);
exports.selectTablesCalculations = (0, toolkit_1.createSelector)([(state) => state.tablesCalculations], (tablesCalculations) => tablesCalculations);
// ----------------------------------------- //
// ------- END SELECTORS FROM STATE -------- //
// ----------------------------------------- //
exports.selectAccountSummary = (0, toolkit_1.createSelector)([
    exports.selectMarginType,
    exports.selectTickers,
    exports.selectEquity,
    exports.selectTableRows,
    exports.selectPageOperationCurrency,
    exports.selectCachedIndices,
    exports.selectTablesCalculations,
], (marginType, tickers, equities, rows, pageOperationCurrency, indices, tablesCalculations) => {
    return pageOperationCurrency === types_1.Currency.ALL
        ? (0, accountSummaryCalculator_1.getAllCurrenciesAccountSummary)(rows, equities, marginType, tickers, indices, tablesCalculations)
        : (0, accountSummaryCalculator_1.getSingleCurrencyAccountSummary)(rows, equities, marginType, tickers, pageOperationCurrency, tablesCalculations);
});
